/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {useStandardizedOptions} from "../../../../../../monitoring/src/Hooks/SharedSurveyHooks";
import CheckboxList from "../../../../../../monitoring/src/Components/Common/CheckboxList";
import React from "react";

/**
 * This component allows us to use the SBM CheckboxList control
 * in SBA Survey view by translating multiple answers into an
 * array of strings.
 * @param props
 * @returns {Element}
 * @constructor
 */
const SurveyFormInputCheckboxList = props => {
	const {
		options,
		value,
		readOnly,
		onChange: parentOnChange,
		primaryKey = 'value',
		labelKey = 'label',
		children,
		clearingOptions = ['None', 'Other'],
	} = props;
	
	const valuesAsArray = value?.split?.(',') ?? [];
	const selectedOptions = options.filter(option => !!(valuesAsArray?.includes?.(option[primaryKey])));
	
	const onChange = async (newValues, lastValue) => {
		const newValuesAsString = newValues?.map?.((x) => x?.[primaryKey])?.join?.(',') ?? [];
		return parentOnChange(newValuesAsString, lastValue)
	};
	
	return (
		<div className={`survey-checkbox-list-input ${readOnly ? 'read-only' : ''}`}>
			<CheckboxList
				data={options}
				primaryKey={primaryKey}
				labelKey={labelKey}
				checked={selectedOptions}
				onChange={onChange}
				readOnly={readOnly}
				clearingOptions={clearingOptions}
			/>
			{
				children
			}
		</div>
	)
};
export default SurveyFormInputCheckboxList;
